<script lang="ts" setup>
</script>

<template>
  <div class="wellness">
    <div class="wellness__header">
      <UiHeader
        :header="$t('wellbeingSale.wellness.header')"
        header-size="h6"
        :subheader="$t('wellbeingSale.wellness.subheader')"
        header-size-mobile="h8"
        subheader-size="body-1"
        subheader-size-mobile="body-1"
        position="center"
      />
    </div>
    
    <p
      class="wellness__data"
      v-html="$t('wellbeingSale.wellness.data')"
    />

    <p
      class="wellness__reason"
      v-html="$t('wellbeingSale.wellness.reason')"
    />

    <img
      class="wellness__photo"
      loading="lazy"
      src="/images/wellbeing-sale/wellness.png"
      alt=""
    >

    <img
      class="wellness__photo wellness__photo--mobile"
      loading="lazy"
      src="/images/wellbeing-sale/wellness_mobile.png"
      alt=""
    >

    <div class="wellness__columns">
      <div
        class="wellness__left-column"
        v-html="$t('wellbeingSale.wellness.columnLeft')"
      />

      <div
        class="wellness__right-column"
        v-html="$t('wellbeingSale.wellness.columnRight')"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.wellness {
  padding: 4rem 1.6rem;

  &__header {
    max-width: 76.7rem;
    width: 100%;

    :deep(.ui-header__subheader) {
      max-width: 55rem;
      width: 100%;
      margin: 2.4rem auto 0 auto;
    }
  }

  &__data {
    @include body-1-medium;
    width: fit-content;
    margin: 2.4rem auto 0 auto;

    padding: 1.3rem 3.4rem;
    background-color: $gray-100;
    border: 1px solid #DDDCE0;
    border-radius: 1.2rem;

    :deep(span) {
      color: $purple-400;
    }
  }

  &__reason {
    @include h10;
    max-width: 32rem;
    width: fit-content;
    margin: 4rem auto 0 auto;
    text-align: center;

    :deep(span) {
      color: $purple-400;
    }
  }

  &__photo {
    display: none;
    margin: 3.6rem auto 0 auto;

    &--mobile {
      display: block;
    }
  }

  &__columns {
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
    max-width: 104.6rem;
    width: 100%;
    margin: 2.4rem auto 0 auto;
  }

  &__left-column {
    @include h10;
    width: 100%;
    text-align: center;
  }

  &__right-column {
    @include body-2-medium;
    display: flex;
    flex-direction: column;
    width: 100%;
    text-align: center;

    :deep(span) {
      color: $purple-400;
    }

    :deep(.wellness__columnParagraph) {
      margin-bottom: 4.5rem;
    }
  }
}

@include atM {
  .wellness {
    padding: 11rem 0;

    &__header {
      margin: 0 auto;

      :deep(.ui-header__subheader) {
        margin: 3.2rem auto 0 auto;
      }
    }

    &__columns {
      flex-direction: row;
      gap: 6rem;
      margin: 5.6rem auto 0 auto;
    }

    &__left-column {
      @include h9;
      width: 55.8rem;
      text-align: left;
    }

    &__right-column {
      @include body-1-medium;
      width: 46.2rem;
      text-align: left;
    }

    &__reason {
      @include h9;
      max-width: unset;
    }

    &__photo {
      display: block;

      &--mobile {
        display: none;
      }
    }
  }
}
</style>
